export const THEME = {
  SYSTEM: 'system',
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export type Theme = (typeof THEME)[keyof typeof THEME];

export const SUPPORTED_LANGUAGES = {
  EN: 'en',
  RU: 'ru',
} as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[keyof typeof SUPPORTED_LANGUAGES];

export interface PAGDefaults {
  readonly enabled: boolean;
  readonly scale: number;
}

export interface FreeUDefaults {
  readonly enabled: boolean;
  readonly b1: number;
  readonly b2: number;
  readonly s1: number;
  readonly s2: number;
}

export interface GenerationDefaults {
  readonly default_checkpoint: string | null;
  readonly default_sampler: string;
  readonly default_scheduler: string;
  readonly default_steps: number;
  readonly default_cfg_scale: number;
  readonly default_width: number;
  readonly default_height: number;
  readonly default_negative_prompt: string;
  readonly default_pag: PAGDefaults;
  readonly default_freeu: FreeUDefaults;
}

export interface UserSettings {
  readonly language: string;
  readonly theme: string;
  readonly generation_defaults: GenerationDefaults;
}

export interface UpdateSettingsRequest {
  readonly language?: string;
  readonly theme?: string;
  readonly generation_defaults?: GenerationDefaults;
}
